import { Tag } from "antd";
import moment from "moment";

import api from "../../../../../api";
import DownloadIcon from "../../../../../svgs/download.svg?react";
import { VatSubmissionEntry } from "../../../../../types";
import { formatAmountInCents } from "../../../../../utils";
import { ClickableTd, H3, StyledTable } from "../../styledComponents";
import { DISPLAY_DATE_FORMAT } from "@/v1/constants";

const VatSubmissionsTable = ({
  submissions,
  email,
}: {
  submissions: VatSubmissionEntry[];
  email: string;
}) => {
  const openPdf = async (email: string, declarationId: string) => {
    const openedWindow = window.open();
    try {
      const PDF = await api.kontax.getDeclarationPdf(email, declarationId);
      if (openedWindow) {
        openedWindow.location.href = PDF;
      }
      setTimeout(function () {
        URL.revokeObjectURL(PDF);
      }, 3000);
    } catch (err) {
      if (openedWindow) openedWindow.close();
    }
  };

  return (
    <>
      <H3>Past declarations</H3>
      <StyledTable>
        <thead>
          <tr>
            <td>Amount</td>
            <td>Time period</td>
            <td>Uploaded on</td>
            <td>Type</td>
            <td>Transmission</td>
            <td>Declaration</td>
          </tr>
        </thead>
        <tbody>
          {submissions.map((declaration) => (
            <tr key={declaration.id}>
              <td>{formatAmountInCents(declaration.amount ?? 0, true)}</td>
              <td>
                {declaration.period}, {declaration.year}
              </td>
              <td>
                {moment(declaration.uploadedAt ?? declaration.createdAt).format(
                  DISPLAY_DATE_FORMAT
                )}
              </td>
              <td>
                {declaration.isCorrection ? (
                  <Tag color="orange">Correction</Tag>
                ) : (
                  <Tag color="blue">Original</Tag>
                )}
              </td>
              <td>
                {declaration.transmissionMethod === "MANUAL" ? (
                  <span>
                    Manual
                    {declaration.submitterEmail && (
                      <span style={{ color: "#888", marginLeft: 4 }}>
                        ({declaration.submitterEmail})
                      </span>
                    )}
                  </span>
                ) : (
                  "Automatic"
                )}
              </td>
              <ClickableTd
                onClick={() => openPdf(email, String(declaration.id))}
              >
                <DownloadIcon />
                {` Open`}
              </ClickableTd>
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </>
  );
};

export default VatSubmissionsTable;
